/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactFormRequest } from '../models/ContactFormRequest';
import type { SuccessView } from '../models/SuccessView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactService {
    /**
     * Submit contact form
     * @param requestBody
     * @returns SuccessView Contact form submitted successfully
     * @throws ApiError
     */
    public static postAppContactSubmit(
        requestBody: ContactFormRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/contact',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                422: `Captcha verification failed`,
                429: `Too many requests`,
            },
        });
    }
}
